import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

export const tooltipActions = (theme: Theme): SerializedStyles =>
  css({
    display: 'flex',
    justifyContent: 'end',
    margin: `${theme.spacing(1)} -${theme.spacing(2)} -${theme.spacing(2)}`,
  })

export const tooltipActionsButton = (theme: Theme): SerializedStyles =>
  css({
    '&:hover': {
      color: theme.palette.primary.dark,
    },
    color: theme.palette.primary.main,
  })
